import { type ReactElement } from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import { ROUTES } from 'constants/routes';
import { ContentDefault } from './components/ContentDefault';
import { TestWellbeing } from './components/TestWellbeing';
import { TrainingsPage } from './components/TrainingsPage';

const wellBeingComponents = {
  trainings: TrainingsPage,
  test: TestWellbeing,
};

export const WellBeingContent = (): ReactElement => {
  const { id, surveyId } = useParams<{ id?: string; surveyId?: string }>();
  const location = useLocation();

  if (location.pathname === ROUTES.WELL_BEING_TEST) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  if (surveyId) return <TestWellbeing />;

  if (!id) return <ContentDefault />;

  const Component = wellBeingComponents[id as keyof typeof wellBeingComponents];
  return Component ? <Component /> : <ContentDefault />;
};
